// src/__internal__/activity/findActivityById.ts
var findActivityById = (id) => (activities) => activities.find(({ id: activityId }) => activityId === id);
export {
  findActivityById
};
